#import "../fragments/plan-group-fragment.graphql"

query GetAvailablePlans {
    recurlyAvailablePlans {
        crm {
            ...PlanGroupFragment
            enabledUsers
            numMarketingLicenses
        }
        marketing {
            ...PlanGroupFragment
            numMarketingContacts
            numMarketingContactsAllowed
            contactUsEndCap
            numMarketingContactsAllowedOverride
        }
        revenueBooster {
            ...PlanGroupFragment
        }
        nutshellIq {
            ...PlanGroupFragment
        }
        inbox {
            ...PlanGroupFragment
            enabledUsers
            numEnabledLicenses
            numBilledLicenses
        }
        smsCampaigns {
            ...PlanGroupFragment
        }
        marketingSuite {
            ...PlanGroupFragment
        }
        quotes {
            ...PlanGroupFragment
        }
        nutshellAdvisor {
            ...PlanGroupFragment
        }
    }
}
